import styled from "styled-components";
import { theme } from "..";
export const HeaderMenuItem = styled.div `
  float: left;
  color: #444;
  height: ${theme.header.lineHeight};
  line-height: ${theme.header.lineHeight};
  padding: 0 10px;
  min-width: ${theme.header.lineHeight};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  :hover {
    color: "#444";
    background: rgba(0, 0, 0, 0.05);
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhZGVyTWVudUl0ZW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29tcG9uZW50cy9IZWFkZXJNZW51SXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFFdkMsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLElBQUksQ0FBQztBQUUzQixNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQTs7O1lBRzVCLEtBQUssQ0FBQyxNQUFNLENBQUMsVUFBVTtpQkFDbEIsS0FBSyxDQUFDLE1BQU0sQ0FBQyxVQUFVOztlQUV6QixLQUFLLENBQUMsTUFBTSxDQUFDLFVBQVU7Ozs7Ozs7Ozs7OztDQVlyQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tIFwic3R5bGVkLWNvbXBvbmVudHNcIjtcclxuXHJcbmltcG9ydCB7IHRoZW1lIH0gZnJvbSBcIi4uXCI7XHJcblxyXG5leHBvcnQgY29uc3QgSGVhZGVyTWVudUl0ZW0gPSBzdHlsZWQuZGl2YFxyXG4gIGZsb2F0OiBsZWZ0O1xyXG4gIGNvbG9yOiAjNDQ0O1xyXG4gIGhlaWdodDogJHt0aGVtZS5oZWFkZXIubGluZUhlaWdodH07XHJcbiAgbGluZS1oZWlnaHQ6ICR7dGhlbWUuaGVhZGVyLmxpbmVIZWlnaHR9O1xyXG4gIHBhZGRpbmc6IDAgMTBweDtcclxuICBtaW4td2lkdGg6ICR7dGhlbWUuaGVhZGVyLmxpbmVIZWlnaHR9O1xyXG4gIHRleHQtYWxpZ246IGNlbnRlcjtcclxuICBkaXNwbGF5OiBmbGV4O1xyXG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XHJcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XHJcblxyXG4gIGN1cnNvcjogcG9pbnRlcjtcclxuXHJcbiAgOmhvdmVyIHtcclxuICAgIGNvbG9yOiBcIiM0NDRcIjtcclxuICAgIGJhY2tncm91bmQ6IHJnYmEoMCwgMCwgMCwgMC4wNSk7XHJcbiAgfVxyXG5gO1xyXG4iXX0=